import { withRouter } from 'next/router';
import Link from 'next/link';
import React, { Children } from 'react';

export const ActiveLink = ({ ariaLabel, router, children, activeClassName, activeDetect, ...props }) => {
  const child = Children.only(children);

  const activeClass = activeClassName || 'active';
  const detect = activeDetect;

  let className = child.props.className || '';
  const route = router.asPath.split('/');
  const baseHost = 'https://www.millesima.com'; // Mocked host to prevent `Invalid URL` error when parsing the URL
  const parsedPath = new URL(router.asPath, baseHost);
  const parsedHref = new URL(props.href || '', baseHost);

  if ((parsedPath.pathname === parsedHref.pathname) || (detect && (detect === route[1]))) {
    className = `${className} ${activeClass}`.trim();
  }

  return <Link aria-label={ariaLabel} className={className} {...props}>{child}</Link>;
};

export default withRouter(ActiveLink);
